<script>
    import CreateImageTask from '../CreateTaskTemplates/CreateImageTask';
    import BaseCreate from './BaseCreate';

    export default {
        extends: CreateImageTask,
        mixins: [BaseCreate],
    };
</script>